import { useNavigate } from "flemo";
import { XIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

export function Header() {
  const { pop } = useNavigate();

  return (
    <header className="relative p-5 pt-2 flex items-center gap-2">
      <Button type="button" variant="ghost" size="icon" aria-label="닫기" onClick={pop}>
        <XIcon className="size-5 text-muted-foreground" />
      </Button>

      <h1 className="text-base font-semibold text-center w-full">프로필</h1>
      <div className="size-8" />
    </header>
  );
}
